import { useRoutes } from "react-router";

// ==============================|| ROUTES ||============================== //

import LandingPageRoutes from "./login_route.js";
import DataRoutes from "./data_routes.js";
import SundriesRoutes from "./sundries_service_routes.js";
import StreakRoutes from "./streak_service_routes.js";
import PurchaseRoutes from "./purchase_service_routes.js";
import RedeemRoutes from "./redeem_service_routes.js";
import PointRoutes from "./point_service_routes.js";
import DashboardRoutes from "./dashboard_service_routes.js";
import AuthRoutes from "./auth_service_routes.js";
import ChallengesRoutes from "./challenge_service_routes.js";
import GameRoutes from "./games_routes.js";
import ClanRoutes from "./clan_services_routes.js";
import PhysioRoutes from "./physio_service_routes.js";
import ResellerRoutes from "./reseller_service_routes.js";
import ExerciseRoutes from "./exercise_service_routes.js";
import CorporateChallengesRoutes from "./corporate_challenges_service_routes.js";

// ==============================|| ROUTING RENDER ||============================== //

export default function Routes() {
    return useRoutes([
        LandingPageRoutes,
        DataRoutes,
        AuthRoutes,
        ChallengesRoutes,
        DashboardRoutes,
        PointRoutes,
        RedeemRoutes,
        PurchaseRoutes,
        StreakRoutes,
        SundriesRoutes,
        GameRoutes,
        ClanRoutes,
        PhysioRoutes,
        ResellerRoutes,
        ExerciseRoutes,
        CorporateChallengesRoutes,
    ]);
}
